module.exports = __webpack_public_path__ + "static/media/gc-lisbon-sight.2c6bbeff.png";